import React from 'react'
import { IoMdInformationCircleOutline } from "react-icons/io";

const SystemInfo = ({data, setData}) => {

    console.log("SystemInfo received data:", data);
    
    // Format date to readable format
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    };

  return (
    <>
    <div className="settingsCard">
        <h4>
          <IoMdInformationCircleOutline /> System Info
        </h4>
        <p>Read-only system metadata and timestamps</p>
        
        <div className='systemInfo'>
            <div className="system-details">
                <div className="info-row">
                    <span className="label">Last Updated By</span>
                    <span className="value">{data?.lastUpdatedBy || 'N/A'}</span>
                </div>
                <div className="info-row">
                    <span className="label">Created At</span>
                    <span className="value">{formatDate(data?.createdAt)}</span>
                </div>
                <div className="info-row">
                    <span className="label">Updated At</span>
                    <span className="value">{formatDate(data?.updatedAt)}</span>
                </div>
            </div>
        </div>
      </div>
    </>
  )
}

export default SystemInfo